import React, { useState } from 'react';
import './FormulaBuilderModal.css';

const MODULE_OPTIONS = [
  'Dashboard',
  'Organization Structure',
  'Workflows',
  'Company OKRs',
  'Personal OKRs',
  'Team OKRs',
  'My OKRs',
  'Annual OKRs',
  'People',
  'Teams',
  'Departments',
  'Visual Map',
  'Safety Procedures',
  'SLAs',
  'Chat',
  'Cost Cards',
  'Template Picker',
  'Create Cost Card',
  'Edit Cost Card',
  'Create Custom Template',
  'Edit Custom Template',
  'Create OKR',
  'Edit OKR',
  'Technical Sales Workflow',
  'Store Management Workflow',
  'Sales Workflow',
  'Import Workflow',
  'Job Descriptions',
  'Employees Reviews',
  'Interview Processes',
  'Company Strategy',
  'Business Continuity Plan',
  'Data Management SOP',
  'Procurement SOP',
  'Risk Compliance SOP',
  'Settings',
  'Search Results',
  'Other',
];

const PRIORITY_OPTIONS = [
  'Critical',
  'High',
  'Medium',
  'Low',
];

function getBrowserInfo() {
  const ua = navigator.userAgent;
  let browser = 'Unknown';
  if (ua.indexOf('Chrome') > -1) browser = 'Chrome';
  else if (ua.indexOf('Safari') > -1) browser = 'Safari';
  else if (ua.indexOf('Firefox') > -1) browser = 'Firefox';
  else if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1) browser = 'IE';
  return browser;
}

function getOSInfo() {
  const platform = navigator.platform;
  if (/Win/.test(platform)) return 'Windows';
  if (/Mac/.test(platform)) return 'MacOS';
  if (/Linux/.test(platform)) return 'Linux';
  if (/Android/.test(platform)) return 'Android';
  if (/iPhone|iPad|iPod/.test(platform)) return 'iOS';
  return 'Unknown';
}

export default function SupportFormModal({ isOpen, onClose, onSubmit, user }) {
  const [name, setName] = useState(user?.name || '');
  const [email, setEmail] = useState(user?.email || '');
  const [issueTitle, setIssueTitle] = useState('');
  const [module, setModule] = useState('Dashboard');
  const [description, setDescription] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [expected, setExpected] = useState('');
  const [steps, setSteps] = useState(['']);
  const [priority, setPriority] = useState('Medium');
  const [attachment, setAttachment] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [ticketId, setTicketId] = useState('');

  if (!isOpen) return null;

  const handleFileChange = e => {
    setAttachment(e.target.files[0]);
  };

  const handleStepChange = (idx, value) => {
    const newSteps = [...steps];
    newSteps[idx] = value;
    setSteps(newSteps);
  };

  const addStep = () => setSteps([...steps, '']);
  const removeStep = idx => setSteps(steps.filter((_, i) => i !== idx));

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    const timestamp = new Date().toISOString();
    const browser = getBrowserInfo();
    const os = getOSInfo();
    const device = navigator.userAgent;
    try {
      const result = await onSubmit({
        name,
        email,
        issueTitle,
        module,
        description,
        errorMessage,
        expected,
        steps: steps.filter(s => s.trim()),
        priority,
        attachment,
        timestamp,
        browser,
        os,
        device,
      });
      if (result && result.success) {
        setSubmitted(true);
        setTicketId(result.ticketId || 'N/A');
      } else {
        setError('Failed to submit. Please try again.');
      }
    } catch (err) {
      setError('Failed to submit. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal support-modal" style={{ maxWidth: 540, width: '98%', padding: '2.5rem 2rem', borderRadius: 18, boxShadow: '0 8px 32px rgba(60,60,60,0.18)', background: '#fff' }}>
        <button className="modal-close" onClick={onClose} style={{ fontSize: 28, top: 18, right: 18 }}>&times;</button>
        <h2 className="modal-title" style={{ color: '#004080', fontWeight: 700, fontSize: 28, marginBottom: 18, textAlign: 'center' }}>Contact IT Support</h2>
        {submitted ? (
          <div style={{ textAlign: 'center', padding: '2rem 0' }}>
            <div style={{ fontSize: 22, fontWeight: 600, color: '#004080', marginBottom: 12 }}>
              Thank you! Your ticket has been submitted.
            </div>
            <div style={{ fontSize: 18, marginBottom: 8 }}>
              <strong>Your ticket:</strong> <span style={{ color: '#004080' }}>#{ticketId}</span>
            </div>
            <div style={{ fontSize: 16, color: '#222', marginBottom: 16 }}>
              We'll get back to you in <strong>1-2 business days</strong>.
            </div>
            <button className="modal-submit" style={{ background: '#004080', color: '#fff', fontWeight: 600, fontSize: 18, borderRadius: 8, padding: '12px 0', marginTop: 8, border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer', transition: 'background 0.2s' }} onClick={onClose}>Close</button>
          </div>
        ) : (
        <form className="support-form" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          <label style={{ fontWeight: 500, color: '#222', marginBottom: 4 }}>
            Name
            <input type="text" value={name} onChange={e => setName(e.target.value)} style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #cbd5e1', fontSize: 16, marginTop: 4, background: '#f8fafc' }} />
          </label>
          <label style={{ fontWeight: 500, color: '#222', marginBottom: 4 }}>
            Email
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #cbd5e1', fontSize: 16, marginTop: 4, background: '#f8fafc' }} />
          </label>
          <label style={{ fontWeight: 500, color: '#222', marginBottom: 4 }}>
            Issue Title (one-line)
            <input type="text" value={issueTitle} onChange={e => setIssueTitle(e.target.value)} required maxLength={100} placeholder="What broke?" style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #cbd5e1', fontSize: 16, marginTop: 4, background: '#f8fafc' }} />
          </label>
          <label style={{ fontWeight: 500, color: '#222', marginBottom: 4 }}>
            Module / Page
            <select value={module} onChange={e => setModule(e.target.value)} style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #cbd5e1', fontSize: 16, marginTop: 4, background: '#f8fafc' }}>
              {MODULE_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </select>
          </label>
          <label style={{ fontWeight: 500, color: '#222', marginBottom: 4 }}>
            Detailed Description
            <textarea value={description} onChange={e => setDescription(e.target.value)} rows={3} required placeholder="Describe the issue in detail..." style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #cbd5e1', fontSize: 16, marginTop: 4, background: '#f8fafc', resize: 'vertical' }} />
          </label>
          <label style={{ fontWeight: 500, color: '#222', marginBottom: 4 }}>
            Error Message (if any)
            <textarea value={errorMessage} onChange={e => setErrorMessage(e.target.value)} rows={2} placeholder="Please include any error messages you received..." style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #cbd5e1', fontSize: 16, marginTop: 4, background: '#f8fafc', resize: 'vertical' }} />
          </label>
          <label style={{ fontWeight: 500, color: '#222', marginBottom: 4 }}>
            What happened vs. what you expected
            <textarea value={expected} onChange={e => setExpected(e.target.value)} rows={2} required placeholder="What did you expect to happen?" style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #cbd5e1', fontSize: 16, marginTop: 4, background: '#f8fafc', resize: 'vertical' }} />
          </label>
          <div style={{ fontWeight: 500, color: '#222', marginBottom: 4 }}>
            Steps to Reproduce
            {steps.map((step, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                <span style={{ marginRight: 8 }}>{idx + 1}.</span>
                <input
                  type="text"
                  value={step}
                  onChange={e => handleStepChange(idx, e.target.value)}
                  placeholder={`Step ${idx + 1}`}
                  style={{ flex: 1, padding: '8px 10px', borderRadius: 8, border: '1.5px solid #cbd5e1', fontSize: 15, background: '#f8fafc' }}
                />
                {steps.length > 1 && (
                  <button type="button" onClick={() => removeStep(idx)} style={{ marginLeft: 6, color: '#b00020', background: 'none', border: 'none', fontSize: 18, cursor: 'pointer' }}>&times;</button>
                )}
              </div>
            ))}
            <button type="button" onClick={addStep} style={{ marginTop: 6, color: '#004080', background: 'none', border: 'none', fontWeight: 600, cursor: 'pointer' }}>+ Add Step</button>
          </div>
          <label style={{ fontWeight: 500, color: '#222', marginBottom: 4 }}>
            Priority / Severity
            <select value={priority} onChange={e => setPriority(e.target.value)} style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #cbd5e1', fontSize: 16, marginTop: 4, background: '#f8fafc' }}>
              {PRIORITY_OPTIONS.map(opt => <option key={opt} value={opt}>{opt}</option>)}
            </select>
          </label>
          <label style={{ fontWeight: 500, color: '#222', marginBottom: 4 }}>
            Attachment (optional)
            <input type="file" accept="image/*,.log,.txt,.pdf" onChange={handleFileChange} style={{ marginTop: 4 }} />
          </label>
          {error && <div className="modal-error" style={{ color: '#b00020', marginBottom: 8 }}>{error}</div>}
          <button type="submit" className="modal-submit" disabled={submitting} style={{ background: '#004080', color: '#fff', fontWeight: 600, fontSize: 18, borderRadius: 8, padding: '12px 0', marginTop: 8, border: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', cursor: 'pointer', transition: 'background 0.2s' }}>
            {submitting ? 'Submitting...' : 'Submit'}
          </button>
        </form>
        )}
      </div>
    </div>
  );
} 